import React, { useState, useEffect, useRef } from "react";

const readOnlyStyle = {
   backgroundColor: "var(--rk-surface-subtle)",
   cursor: "not-allowed",
};

const CurrencyInput = ({ value, onAmountChange, placeholder = "0.00", className = "", readOnly = false }) => {
   const [localValue, setLocalValue] = useState(value || "");
   const inputRef = useRef(null);

   useEffect(() => {
      if (document.activeElement !== inputRef.current) {
         setLocalValue(value);
      }
   }, [value]);

   const handleChange = (e) => {
      let newValue = e.target.value;

      // Allow only numbers, one decimal point, and max two decimals
      if (/^-?\d*\.?\d{0,2}$/.test(newValue) || newValue === "") {
         setLocalValue(newValue);
         onAmountChange?.(newValue); // <-- Notify parent immediately
      }
   };

   const handleBlur = () => {
      if (localValue !== "") {
         // Remove all characters except digits, one dot, and dash
         const cleaned = localValue.replace(/[^\d.-]/g, "");

         // Count hyphens
         const minusCount = (cleaned.match(/-/g) || []).length;

         // Valid only if one or zero dashes
         const isNegative = cleaned.includes("-") && minusCount === 1;

         // Remove dashes for parsing
         const numericPart = cleaned.replace(/-/g, "");

         if (!isNaN(numericPart)) {
            const formatted = parseFloat(numericPart).toFixed(2);
            const formattedValue = isNegative ? `-${formatted}` : formatted;
            setLocalValue(formattedValue);
            onAmountChange?.(formattedValue);
         } else {
            setLocalValue("");
         }
      } else {
         setLocalValue(""); // Reset invalid input
      }
   };

   return (
      <input
         type="text"
         ref={inputRef}
         value={localValue}
         onChange={handleChange}
         onBlur={handleBlur}
         className={`form-control ${className}`}
         placeholder={placeholder}
         inputMode="decimal"
         style={{
            textAlign: "right",
            ...(readOnly ? readOnlyStyle : {}), // Apply readOnlyStyle if readOnly is true
         }}
         readOnly={readOnly}
      />
   );
};

export default CurrencyInput;
